import React from 'react';
import { IconCheckBold, IconLowestBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { TouchAccessibilityWrapper } from '@domains/pdp-common';

import { Button } from '../../../types/benefit';

export const ButtonDownload = (button: Button) => {
  return (
    <TouchAccessibilityWrapper
      touchWidth={72}
      touchHeight={36}
      onClick={button.disable ? () => {} : () => button.onClick()}
    >
      <Container disabled={button.disable} color={button.uiSetting?.color ?? vars.color.pink400}>
        {button.disable ? (
          <IconCheckBold width={16} height={16} color='textDisabled' />
        ) : (
          <IconLowestBold width={16} height={16} style={{ color: button.uiSetting?.color ?? vars.color.pink400 }} />
        )}
        <span>{button.text}</span>
      </Container>
    </TouchAccessibilityWrapper>
  );
};

const Container = styled.button<{ color?: string; disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 12px 0 8px;
  min-height: 24px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;

  ${({ color }) => `
    color: ${color ?? vars.color.pink400};
  `};

  ${({ color, disabled }) =>
    disabled
      ? `color: ${vars.color.textDisabled};
         background: ${vars.color.fillDisabled};`
      : `border: 1px solid ${color ?? vars.color.pink400};`};
`;
